<section class="container">

  <div class="row">
    <div class="col">
      <h3 class="bn-title">Cadastro de Modalidade SCR</h3>
    </div>

    <div class="col-auto">
      <button type="button" class="btn btn-danger no-margin" (click)="cancelar()">Cancelar</button>
    </div>

    <div class="col-auto">
      <button type="button" class="btn btn-primary no-margin" (click)="salvar()" [disabled]="form.invalid">Salvar</button>
    </div>
  </div>

  <form [formGroup]="form">
    <div class="row">
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="codigoScrModalidade">Código modalidade</label>
        <input type="text" class="form-control" id="codigoScrModalidade" formControlName="codigoScrModalidade"
          placeholder="Somente números">
        <div
          *ngIf="form.get('codigoScrModalidade').invalid && (form.get('codigoScrModalidade').dirty || form.get('codigoScrModalidade').touched)"
          class="text-danger">
          <small *ngIf="form.get('codigoScrModalidade').errors?.pattern">Digite apenas números.</small>
        </div>
      </div>

      <div class="bn-form-group col-md-4">
        <label class="form-label" for="tipoScrModalidade">Tipo modalidade</label>
        <select class="form-select" id="tipoScrModalidade" formControlName="tipoScrModalidade">
          <option [ngValue]="null">Selecione</option>
          <option *ngFor="let item of listaTiposModalidade" [ngValue]="item.valor">{{ item.nome }}</option>
        </select>
      </div>

      <div class="bn-form-group col-md-4">
        <label class="form-label" for="tipoCliente">Tipo Cliente</label>
        <select class="form-select" id="tipoCliente" formControlName="tipoCliente">
          <option [ngValue]="null">Selecione</option>
          <option *ngFor="let item of listaTiposCliente" [ngValue]="item.valor">{{ item.nome }}</option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="bn-form-group col-md-12">
        <label class="form-label" for="nomeScrModalidade">Descrição modalidade</label>
        <textarea class="form-control" id="nomeScrModalidade" formControlName="nomeScrModalidade"
          rows="3"></textarea>
      </div>
    </div>

  </form>
</section>